<template>
  <div class="stationAppointment">
    <NavBar v-if="sourceIsH5" :narBarTitle="$t('工位预约')" />
    <van-action-sheet v-model="stationShow" :actions="stationList" :title="$t('选择空间')" @select="onStationConfirm" />
    <van-action-sheet v-model="areaShow" :actions="areaList" :title="$t('选择工区')" @select="onAreaConfirm" />
    <van-calendar v-model="dateShow" @confirm="onConfirm" :title="$t('日期筛选')" color="#009BFF" :formatter="formatter"
      :max-date="configShowDayMin" />
    <div class="selectionBar">
      <div @click="stationShow = true" class="selectionBar-area">
        <img src="@/assets/images/workStationIcon.png" alt="" class="selectionBar-location" />
        <span class="area-font">{{ station }}</span>
        <img src="@/assets/images/icon_dropdown.png" alt="" class="selectionBar-down" />
      </div>
      <div class="myStationGoBlock">
        <div class="myStationGo" @click="handleGo">{{ $t('我的预约') }}</div> <img src="@/assets/images/workStationArrow.png" alt="" />
      </div>
    </div>
    <div class="calendarWeed">
      <div class="timeLine">
        <div v-for="item in weekdayList" :key="item.today" class="dayBlock" :style="{
          backgroundColor: item.backgroundColor,
          opacity: item.opacity,
          borderWidth: item.borderWidth,
          borderRadius: item.borderRadius,
          borderColor: item.borderColor,
          borderStyle: item.borderStyle,
        }" @click="choseWeekDay(item)">
          <div class="dayBlockweek" :style="{
            color: item.colorWeek,
            // fontWeight: item.fontWeightWeek,
          }">{{ item.weekday }}</div>
          <div :style="{
            color: item.color,
            fontWeight: item.fontWeightDay,
          }">{{ item.today }}</div>
        </div>
      </div>
      <div class="calendar" @click="dateShow = true">
        <img src="@/assets/images/calendar.png" alt="" />
        <!-- <img src="@/assets/images/calendar-down.png" alt="" class="calendar-down" /> -->
      </div>
    </div>

    <div class="stationListWrapper">
      <div class="stationListWrapper-area">
        <div @click="areaShow = true" class="selectionBar-areaO">
          <div class="area-fontA">{{ area }}</div>
          <img src="@/assets/images/icon_dropdown.png" alt="" class="selectionBar-downO" />
        </div>
        <div v-if="appointmentConfig?.mixMakeDay == 'DAY'" class="day-time">
          <div>{{ startTime }}</div>
          <div class="day-timeLine">-</div>
          <div>{{ endTime }}</div>
        </div>
        <div v-if="appointmentConfig?.mixMakeDay == 'CUSTOM_TIME'" @click="customShow = true">
          <div v-if="startTime" class="custom-time">
            <div class="custom-timeLeft">
              <div>{{ startTime }} - {{ endTime }}</div>
              <div v-if="customIdList.length > 1">...</div>
            </div>
            <img src="@/assets/images/icon_dropdown.png" alt="" class="selectionBar-downO" />
          </div>
          <div v-else class="custom-notime">
            <img src="@/assets/images/icon_dropdown.png" alt="" class="selectionBar-downO" />
          </div>
        </div>
        <div v-if="appointmentConfig?.mixMakeDay == 'HOURS'" class="day-time">
          <div @click="showStartTimeHour = true">{{ startTime }}</div>
          <div class="day-timeLine">-</div>
          <div @click="showEndTimeHour = true">{{ endTime }}</div>
        </div>
        <div v-if="appointmentConfig?.mixMakeDay == 'HALF_A_HOUR'" class="day-time">
          <div @click="showStartTimeHalfHour = true">{{ startTime }}</div>
          <div class="day-timeLine">-</div>
          <div @click="showEndTimeHalfHour = true">{{ endTime }}</div>
        </div>
      </div>
      <div v-for="item in stationAppointmentList" :key="item.workAreaId">
        <station-item :item="item" :area="station"></station-item>
      </div>
      <no-data-warning v-if="stationAppointmentList.length === 0 && !loading"></no-data-warning>
      <div class="appointmentStatusIconWrapper">
        <div class="typeStatusIcon">
          <div class="appointmentTypeStatusIcon">
            <span>
              {{ $t('流动工位') }}
            </span>
            <div class="appointmentFlowStatusIcon">
              <div class="appointmentStatusIcon" v-for="item in appointmentFlowStatusIcon" v-bind:key="item.name">
                <img :src="item.src" class="iconItem" />
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="appointmentTypeStatusIcon">
            <span>
              {{ $t('固定工位') }}
            </span>
            <div class="appointmentStatusIcon" v-for="item in appointmentFixedStatusIcon" v-bind:key="item.name">
              <img :src="item.src" class="iconItem" />
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-loading v-if="this.loading" vertical type="spinner">{{
      $t('加载中...')
      }}</van-loading>
    <van-popup v-model="customShow" position="bottom" safe-area-inset-bottom>
      <div>
        <div class="timeListTitle">{{ $t('选择自定义时段') }}</div>
        <van-checkbox-group v-model="customIdList" class="timeList">
          <div style="position: absolute; top: 0; height: 318px">
            <van-checkbox :name="index" class="timeListCard" icon-size="21px" v-for="(item, index) in customList"
              :key="index" @click="clickCustom(index)">
              <div class="timeListRange">{{ item.value }}</div>
            </van-checkbox>
          </div>
        </van-checkbox-group>
      </div>
      <div class="bookBox">
        <van-button round block type="info" native-type="submit" class="book-btn" @click="toCustomInform">{{
          $t('确定')
          }}</van-button>
      </div>
    </van-popup>
    <van-popup v-model="showStartTimeHour" position="bottom" safe-area-inset-bottom @close-on-click-overlay="false">
      <van-datetime-picker :type="'time'" :title="$t('选择开始时间')" :value="startTimeHour" :filter="filterStartTime"
        :min-hour="dayjs().format('HH')" @confirm="handleConfirmStartHour" @cancel="showStartTimeHour = false" />
    </van-popup>
    <van-popup v-model="showEndTimeHour" position="bottom" safe-area-inset-bottom @close-on-click-overlay="false">
      <van-datetime-picker :type="'time'" :title="$t('选择结束时间')" :value="endTimeHour" :filter="filterEndTime"
        :min-hour="dayjs().format('HH')" @confirm="handleConfirmEndHour" @cancel="showEndTimeHour = false"
        @change="handleChangeEndHour" />
    </van-popup>
    <van-popup v-model="showStartTimeHalfHour" position="bottom" safe-area-inset-bottom @close-on-click-overlay="false">
      <van-datetime-picker :type="'time'" :title="$t('选择开始时间')" :value="startTimeHalfHour" :filter="filterStartTimeHalf"
        :min-hour="dayjs().format('HH')" @confirm="handleConfirmStartHalfHour"
        @cancel="showStartTimeHalfHour = false" />
    </van-popup>
    <van-popup v-model="showEndTimeHalfHour" position="bottom" safe-area-inset-bottom @close-on-click-overlay="false">
      <van-datetime-picker :type="'time'" :title="$t('选择结束时间')" :value="endTimeHalfHour" :filter="filterEndTimeHalf"
        :min-hour="dayjs().format('HH')" @confirm="handleConfirmEndHalfHour" @cancel="showEndTimeHalfHour = false"
        @change="handleChangeEndHalfHour" />
    </van-popup>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import StationItem from './components/stationItem'
import NoDataWarning from '@/components/NoDataWarning'
import {
  queryAppointmentSpaceOrWorkAreaList,
  queryAppointmentStaion,
  queryShowDayMin,
  querySuperiorWorkspace,
  queryStationParent,
  getWorkAreaList,
  queryAppointmentSeetingConfig,
} from '@/services/api'
import Vue from 'vue'
import dayjs from 'dayjs'
import { getWebSocketOrigin } from '@/utils/utils'
// import { EasyScroller } from 'easyscroller'
import {
  transformStationXY,
  getStatusIconUrl,
  getWorkAreaStationScale,
} from '@/utils/utils'
import fixedIcon from '@/assets/images/fixed.png' // 固定工位
import ellipse1Icon from '@/assets/images/bubble-1.png' // 气泡空闲状态
import ellipse2Icon from '@/assets/images/bubble-3.png' // 气泡部分空闲
import ellipse3Icon from '@/assets/images/bubble-2.png' // 气泡约满
import ellipse4Icon from '@/assets/images/bubble-4.png' // 气泡不可用
import fixed1Icon from '@/assets/images/fixed-1.png' // 固定工位：已分配
import fixed2Icon from '@/assets/images/fixed-2.png' // 固定工位：未分配

import {
  Calendar,
  Dialog,
  Toast,
  ActionSheet,
  Tab,
  Tabs,
  Search,
  Popup,
  PullRefresh,
  List,
  Loading,
  Field,
  Checkbox,
  CheckboxGroup,
  Button,
  DatetimePicker
} from 'vant'
Vue.use(Calendar)
Vue.use(Toast)
Vue.use(ActionSheet)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Popup)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Field)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(CheckboxGroup)
Vue.use(DatetimePicker)

export default {
  name: 'BookMeetings',
  components: {
    NavBar,
    StationItem,
    NoDataWarning,
  },
  data() {
    return {
      sourceIsH5: true,
      date: '',
      areaShow: false,
      stationShow: false,
      weekdayList: [],
      area: '',
      areaList: [],
      areaId: '',
      areaIdList: [],
      station: '',
      stationList: [],
      stationId: '',
      stationIdList: [],
      parameterDate: '',
      dateShow: false,
      stationAppointmentList: [],
      maxConfigShowDayMin: new Date(dayjs().add(30 * 6, 'day')),
      configShowDayMin: new Date(dayjs().add(30 * 6, 'day')), // 工位可用预约的最小时间-默认无限制（接口多个空间时最小的，单个空间直接返回配置的信息）
      loading: false,
      appointmentConfig: {}, // web端配置的工位预约时间断类型信息
      startTime: '',
      endTime: '',
      customList: [],
      customIdList: [],
      customShow: false,
      choseTime: '',
      showStartTimeHour: false,
      showEndTimeHour: false,
      startTimeHour: '',
      endTimeHour: '',
      showStartTimeHalfHour: false,
      showEndTimeHalfHour: false,
      startTimeHalfHour: '',
      endTimeHalfHour: '',
      checkedEndH: '',
      checkedEndHH: '',
      appointmentFlowStatusIcon: [
        { name: this.$t('全部空闲'), color: '#8ED30C', src: ellipse1Icon },
        { name: this.$t('部分空闲'), color: '#FFA200', src: ellipse2Icon },
        { name: this.$t('约满'), color: '#E34444', src: ellipse3Icon },
        { name: this.$t('不可用'), color: '#B7B7B7', src: ellipse4Icon },
      ],
      appointmentFixedStatusIcon: [
        { name: this.$t('已分配'), color: '#8ED30C', src: fixed1Icon },
        { name: this.$t('未分配'), color: '#8ED30C', src: fixed2Icon },
      ],
    }
  },
  methods: {
    scheduleNextCheck() {
      const now = new Date();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      let delay;

      if (minutes < 30) {
        delay = (30 - minutes) * 60000 - seconds * 1000;
      } else if (minutes < 60) {
        delay = (60 - minutes) * 60000 - seconds * 1000;
      }

      this.timer = setTimeout(() => {
        this.executeTask();
        this.scheduleNextCheck(); // 递归调用设置下一次
      }, delay);
    },
    stopSchedule() {
      if (this.timer) clearTimeout(this.timer);
    },
    executeTask() {
      this.queryInit()
    },
    clickCustom(index) {
      if (this.customIdList.length < 2) return
      if (!this.customIdList.some((num) => num == index)) return
    },
    toCustomInform() {
      if (!this.customIdList.length) {
        this.startTime = ''
        this.endTime = ''
      } else {
        let list = []
        this.customIdList.sort(function (a, b) {
          return a - b
        })
        this.customIdList.map((item) => {
          list.push({
            startTime: this.customList[item].value.split('-')[0],
            endTime: this.customList[item].value.split('-')[1],
          })
        })
        const earliestStartEvent = list.reduce((prev, current) => {
          const prevTime = dayjs(prev.startTime, "HH:mm");
          const currentTime = dayjs(current.startTime, "HH:mm");
          return prevTime.isBefore(currentTime) ? prev : current;
        });
        const latestEndEvent = list.reduce((prev, current) => {
          const prevTime = dayjs(prev.endTime, "HH:mm");
          const currentTime = dayjs(current.endTime, "HH:mm");
          return prevTime.isAfter(currentTime) ? prev : current;
        });
        this.startTime = earliestStartEvent.startTime
        this.endTime = latestEndEvent.endTime
      }
      this.customShow = false
      this.queryAppointmentStaionList({
        date: this.choseTime,
        workspaceId: this.stationId,
        areaId: this.areaId
      })
    },
    filterStartTime(type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 60 === 0)
      }
      return options;
    },
    filterEndTime(type, options) {
      if (type === 'minute') {
        if (this.checkedEndH == 23) {
          return options.filter(option => option % 60 === 0 || option % 59 === 0)
        } else {
          return options.filter(option => option % 60 === 0)
        }
      }
      return options;
    },
    filterStartTimeHalf(type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 30 === 0)
      }
      return options;
    },
    filterEndTimeHalf(type, options) {
      if (type === 'minute') {
        if (this.checkedEndHH == 23) {
          return options.filter(option => option % 30 === 0 || option % 59 === 0)
        } else {
          return options.filter(option => option % 30 === 0)
        }
      }
      return options;
    },
    handleConfirmStartHour(date) {
      let start = dayjs(date, "HH:mm")
      let end = dayjs(this.endTimeHour, "HH:mm")
      if (end.isAfter(start)) {
        this.startTime = date
        this.startTimeHour = date
        this.queryAppointmentStaionList({
          date: this.choseTime,
          workspaceId: this.stationId,
          areaId: this.areaId
        })
        this.showStartTimeHour = false
      } else {
        Toast.fail(this.$t('开始时间需要晚于结束时间'))
        return
      }
    },
    handleConfirmEndHour(date) {
      let start = dayjs(this.startTimeHour, "HH:mm")
      let end = dayjs(date, "HH:mm")
      if (end.isAfter(start)) {
        this.endTime = date
        this.endTimeHour = date
        this.queryAppointmentStaionList({
          date: this.choseTime,
          workspaceId: this.stationId,
          areaId: this.areaId
        })
        this.showEndTimeHour = false
      } else {
        Toast.fail(this.$t('开始时间需要晚于结束时间'))
        return
      }
    },
    handleChangeEndHour(event) {
      const cH = event.getValues()[0]
      this.checkedEndH = cH
    },
    handleChangeEndHalfHour(event) {
      const cH = event.getValues()[0]
      this.checkedEndHH = cH
    },
    handleConfirmStartHalfHour(date) {
      let start = dayjs(date, "HH:mm")
      let end = dayjs(this.endTimeHalfHour, "HH:mm")
      if (end.isAfter(start)) {
        this.startTime = date
        this.startTimeHalfHour = date
        this.queryAppointmentStaionList({
          date: this.choseTime,
          workspaceId: this.stationId,
          areaId: this.areaId
        })
        this.showStartTimeHalfHour = false
      } else {
        Toast.fail(this.$t('开始时间需要晚于结束时间'))
        return
      }
    },
    handleConfirmEndHalfHour(date) {
      let start = dayjs(this.startTimeHalfHour, "HH:mm")
      let end = dayjs(date, "HH:mm")
      if (end.isAfter(start)) {
        this.endTime = date
        this.endTimeHalfHour = date
        this.queryAppointmentStaionList({
          date: this.choseTime,
          workspaceId: this.stationId,
          areaId: this.areaId
        })
        this.showEndTimeHalfHour = false
      } else {
        Toast.fail(this.$t('开始时间需要晚于结束时间'))
        return
      }
    },
    formatter(day) {
      if (
        dayjs(day.date).format('YYYY-MM-DD') ==
        dayjs(new Date()).format('YYYY-MM-DD')
      ) {
        day.className = 'date-border'
      }
      return day
    },
    handleGo() {
      this.$router.push({
        path: `/station/myStation`,
      })
    },
    getNowFormatDate(date) {
      let seperator1 = '-'
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      let currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    async getAreaId(developerId) {
      try {
        // const res = await getIncludeWorkspace({
        //   developerId,
        // })
        // const { data = [] } = await queryAppointmentSpaceOrWorkAreaList(developerId)
        // const data = await querySuperiorWorkspace({
        //   developerId,
        //   selectionType: 'STATION_AREA',
        // })
        this.choseTime = this.getNowFormatDate(new Date())
        const data = await queryStationParent({
          developerId,
          // selectionType: 'STATION_AREA',
        })
        data?.forEach((v) => {
          this.stationIdList.push(v.id)
          this.stationList.push({ name: v.name, id: v.id })
        })
        this.station = this.stationList[0].name
        this.stationId = this.stationIdList[0]
        this.parameterDate = new Date()
        this.handleQueryShowDayMin({ companyId: this.user.companyId, workSpaceId: this.stationId, })
        this.queryInit()
      } catch (error) {
        console.log(error.response.data.message)
      }
    },
    async queryInit() {
      let _stationSettingConfig = await queryAppointmentSeetingConfig(
        this.stationId
      )
      //mock
      this.appointmentConfig = _stationSettingConfig.data
      if (_stationSettingConfig?.data?.mixMakeDay == 'DAY') {
        let flowDayRuleTime = _stationSettingConfig?.data?.flowDayRuleTime
        this.startTime = flowDayRuleTime?.split('-')[0]
        this.endTime = flowDayRuleTime?.split('-')[1]
      } else if (_stationSettingConfig?.data?.mixMakeDay == 'CUSTOM_TIME') {
        let customPeriod = _stationSettingConfig?.data?.customPeriod ? JSON.parse(_stationSettingConfig?.data?.customPeriod) : []
        customPeriod.map((item, index) => {
          this.customList.push({
            id: index,
            value: item.value
          })
        })
        this.customIdList = []
        let list = customPeriod?.find((v, index) => {
          const time = v.value.split('-')
          const sT = `${dayjs().format('YYYY-MM-DD')} ${time[0]}:00`
          const eT = `${dayjs().format('YYYY-MM-DD')} ${time[1]}:00`
          if (dayjs().isAfter(sT) && dayjs().isBefore(eT)) {
            this.customIdList.push(index)
            return v
          }
        })
        if (list) {
          this.startTime = list?.value ? list.value?.split('-')[0] : ''
          this.endTime = list?.value ? list.value?.split('-')[1] : ''
        } else {
          this.startTime = ''
          this.endTime = ''
        }
      } else if (_stationSettingConfig?.data?.mixMakeDay == 'HOURS') {
        this.startTime = dayjs().format('HH:00')
        this.endTime = dayjs().add(1, 'hour').format('HH:00')
        this.startTimeHour = dayjs().format('HH:00')
        this.endTimeHour = dayjs().add(1, 'hour').format('HH:00')
      } else {
        if (dayjs().isBefore(dayjs().set('minute', 30))) {
          this.startTime = dayjs().format('HH:00')
          this.endTime = dayjs().format('HH:30')
          this.startTimeHalfHour = dayjs().format('HH:00')
          this.endTimeHalfHour = dayjs().format('HH:30')
        } else {
          this.startTime = dayjs().format('HH:30')
          this.endTime = dayjs().add(1, 'hour').format('HH:00')
          this.startTimeHalfHour = dayjs().format('HH:30')
          this.endTimeHalfHour = dayjs().add(1, 'hour').format('HH:00')
        }
      }
      this.queryAllArea({
        date: this.choseTime,
        workspaceId: this.stationId,
      })
    },
    async onStationConfirm(v, idx) {
      this.checkedEndH = ''
      this.checkedEndHH = ''
      this.station = v.name
      this.stationShow = false
      this.stationId =
        this.stationIdList[idx] === undefined ? -1 : this.stationIdList[idx]

      const workspaceId =
        this.stationIdList[idx] === undefined ? -1 : this.stationIdList[idx]
      this.workSpaceId = workspaceId
      // this.getWeekdayTime(new Date())
      this.choseTime = this.getNowFormatDate(new Date())
      this.handleQueryShowDayMin({
        companyId: this.user.companyId,
        workSpaceId: workspaceId,
      })
      this.queryInit()
      // this.queryAllArea({
      //   date: this.getNowFormatDate(new Date()),
      //   workspaceId,
      // })
      // await this.queryAppointmentStaionList({
      //   date: this.getNowFormatDate(new Date()),
      //   workspaceId,
      // })
    },
    async onAreaConfirm(v, idx) {
      this.area = v.name
      this.areaShow = false
      this.areaId =
        this.areaIdList[idx] === undefined ? -1 : this.areaIdList[idx]

      const areaId =
        this.areaIdList[idx] === undefined ? -1 : this.areaIdList[idx]
      this.areaId = areaId
      // this.getWeekdayTime(new Date())
      this.queryAppointmentStaionList({
        date: this.getNowFormatDate(new Date()),
        workspaceId: this.stationId,
        areaId: areaId
      })
    },
    changeDisableDateItem(day) {
      let item = {
        bg: 'transparent',
        disalbe: false,
        opacity: 1,
        color: '#474D57',
        colorWeek: '#B7BDC6',
      }
      const curDay = day.format('YYYY-MM-DD')
      const maxDay = this.getNowFormatDate(this.configShowDayMin)
      if (dayjs(curDay).isAfter(maxDay)) {
        item = {
          bg: '#eeeeee',
          disalbe: true,
          opacity: 0.3,
          color: '#B7BDC6',
          colorWeek: '#B7BDC6',
        }
      }
      return item
    },
    async getWeekdayTime(date) {
      let allDay = []
      let weekday = new Array(7)
      weekday[0] = this.$t('周日')
      weekday[1] = this.$t('周一')
      weekday[2] = this.$t('周二')
      weekday[3] = this.$t('周三')
      weekday[4] = this.$t('周四')
      weekday[5] = this.$t('周五')
      weekday[6] = this.$t('周六')

      for (let i = 0; i < 7; i++) {
        let day = dayjs(date).add(i, 'day')
        // let time = `${ new Date(day).getMonth() + 1 } -${ new Date(day).getDate() } `
        let time = `${new Date(day).getDate()} `
        let week = weekday[new Date(day).getDay()]
        if (i == 0) {
          if (dayjs().isSame(dayjs(day), 'day')) {
            const curItem = this.changeDisableDateItem(day)
            allDay.push({
              day: day,
              // today: this.$t('今天'),
              today: time,
              weekday: week,
              color: '#1890FF',
              colorWeek: '#1890FF',
              backgroundColor: curItem.disalbe ? curItem.bg : 'transparent',
              // backgroundColor: 'transparent',
              fontWeightDay: 600,
              // opacity: curItem.disalbe ? curItem.opacity : 1,
              borderWidth: '3px',
              borderRadius: '8px',
              borderColor: '#1890FF',
              borderStyle: 'solid'
            })
          } else {
            const curItem = this.changeDisableDateItem(day)

            allDay.push({
              day: day,
              today: time,
              weekday: week,
              color: curItem.disalbe ? '#B7BDC6' : '#474D57',
              colorWeek: '#B7BDC6',
              backgroundColor: curItem.disalbe ? curItem.bg : 'transparent',
              // backgroundColor: 'transparent',
              fontWeightDay: 400,
              // opacity: curItem.disalbe ? curItem.opacity : 1,
              borderWidth: '3px',
              borderRadius: '8px',
              borderColor: 'transparent',
              borderStyle: 'solid'
            })
          }
        } else {
          const curItem = this.changeDisableDateItem(day)

          allDay.push({
            day: day,
            today: time,
            weekday: week,
            color: curItem.disalbe ? '#B7BDC6' : '#474D57',
            colorWeek: '#B7BDC6',
            backgroundColor: curItem.disalbe ? curItem.bg : 'transparent',
            // backgroundColor: 'transparent',
            fontWeightDay: curItem ? 600 : 400,
            borderWidth: '3px',
            borderRadius: '8px',
            borderColor: 'transparent',
            borderStyle: 'solid'
            // opacity: curItem.opacity,
          })
        }
      }
      this.weekdayList = allDay
    },
    // 选择周日历
    async choseWeekDay(data) {
      if (this.changeDisableDateItem(data.day).disalbe) {
        return
      }

      this.weekdayList.map((item) => {
        if (item.weekday == data.weekday) {
          item.color = '#1890FF'
          item.colorWeek = '#1890FF'
          // item.backgroundColor = '#E0EEFF'
          item.backgroundColor = 'transparent'
          // item.opacity = 1
          item.borderWidth = '3px'
          item.borderRadius = '8px'
          item.borderColor = '#1890FF'
          item.borderStyle = 'solid'
        } else {
          item.color = this.changeDisableDateItem(item.day).color
          item.colorWeek = this.changeDisableDateItem(item.day).colorWeek
          item.backgroundColor = this.changeDisableDateItem(item.day).bg
          item.borderWidth = '3px'
          item.borderRadius = '8px'
          item.borderColor = 'transparent'
          item.borderStyle = 'solid'
          // item.backgroundColor = this.changeDisableDateItem(item.day).bg
          // item.opacity = this.changeDisableDateItem(item.day).opacity
        }
      })
      let date = new Date(data.day)
      this.date = this.formatDate(date)
      this.parameterDate = date
      this.choseTime = this.getNowFormatDate(date)
      await this.queryAppointmentStaionList({
        date: this.getNowFormatDate(date),
        workspaceId: this.stationId,
        areaId: this.areaId,
      })
    },
    // 日期选择
    async onConfirm(date) {
      this.date = this.formatDate(date)
      this.$refs.rangeBox && (this.$refs.rangeBox.style.top = 0)
      this.parameterDate = date
      this.getWeekdayTime(date)

      this.dateShow = false

      await this.queryAppointmentStaionList({
        date: this.getNowFormatDate(date),
        workspaceId: this.stationId,
        areaId: this.areaId
      })
    },
    formatDate(date) {
      let weekday = new Array(7)
      weekday[0] = this.$t('周日')
      weekday[1] = this.$t('周一')
      weekday[2] = this.$t('周二')
      weekday[3] = this.$t('周三')
      weekday[4] = this.$t('周四')
      weekday[5] = this.$t('周五')
      weekday[6] = this.$t('周六')

      return this.$t('{slot1}月{slot2}日 {slot3}', {
        slot1: date.getMonth() + 1,
        slot2: date.getDate(),
        slot3: weekday[date.getDay()],
      })
    },
    /**
     * date: 日期
     * workspaceId: 空间
     */
    async queryAllArea({ date, workspaceId }) {
      const data = await getWorkAreaList({
        spaceId: workspaceId,
        developerId: this.user.companyId,
        companyId: this.user.companyId
      })
      this.areaIdList = []
      this.areaList = []
      data?.data?.forEach((v) => {
        this.areaIdList.push(v.id)
        this.areaList.push({ name: v.workAreaName, id: v.id })
      })
      this.area = this.areaList[0].name
      this.areaId = this.areaIdList[0]
      this.queryAppointmentStaionList({
        date: date,
        workspaceId: workspaceId,
        areaId: this.areaIdList[0]
      })
    },
    async queryAppointmentStaionList({ date, workspaceId, areaId }) {
      this.loading = true
      const res = await queryAppointmentStaion({
        companyId: this.user.companyId,
        startTime: `${date} ${this.startTime ? this.startTime + ':00' : '00:00:00'}`,
        endTime: `${date} ${this.endTime ? this.endTime + ':00' : '23:59:59'}`,
        workspaceId,
        areaId,
        source: '1',

        // companyId: 253,
        // endTime: '2022-10-20 23:59:59',
        // startTime: '2022-10-20 00:00:00',
        // workspaceId: -1,
      })
      this.loading = false

      if (!res.data) {
        this.stationAppointmentList = []
        return
      }
      const list = []
      res.data.stationReserveList &&
        res.data.stationReserveList.forEach((v) => {
          let _stationXYList = []
          v.stationStatusList.forEach((element) => {
            _stationXYList.push({
              id: element.id,
              type: 'img',
              src: getStatusIconUrl(
                element.iconType,
                element.makeState,
                element
              ),
              width: getWorkAreaStationScale(
                element.wide ? Number(element.wide) : 0, 2.999
              ),
              height: getWorkAreaStationScale(
                element.height ? Number(element.height) : 0, 2.999
              ),
              top: getWorkAreaStationScale(
                transformStationXY(element.coordinate).y, 2.999
              ),
              left: getWorkAreaStationScale(
                transformStationXY(element.coordinate).x, 2.999
              ),
              // stationName: element.stationName,
              // stationState: element.stationState,
              makeState: element.makeState,
            })
          })
          list.push({
            stationStatusList: _stationXYList,
            workAreaSetting: v.workAreaSetting,
            stationLeisureCount: v.stationLeisureCount,
            workAreaId: v.workAreaId,
            date,
            startTime: this.startTime ? this.startTime + ':00' : '00:00:00',
            endTime: this.endTime ? this.endTime + ':00' : '23:59:59',
          })
        })
      this.stationAppointmentList = list
    },
    connectWebSocket() {
      let url = `${getWebSocketOrigin()} /newworkwss/ws / ${this.user.id} `
      this.webSocket = new WebSocket(url)

      this.webSocket.onopen = () => {
        console.log('websocket连接成功')
      }
      this.webSocket.onclose = () => {
        this.webSocket.close()
        console.log('websocket连接已关闭')
      }
      this.webSocket.onmessage = (res) => {
        if (res.data.indexOf(this.$t('成功')) != -1) return
        try {
          const message = JSON.parse(res.data)
          if (message?.msgType == 'station') {
            console.log('更新了')
            this.queryAppointmentStaionList({
              date: this.getNowFormatDate(this.parameterDate),
              workspaceId: this.stationId,
              areaId: this.areaId
            })
          }
        } catch (ignore) { }
      }
      this.webSocket.onerror = (res) => {
        console.log('websocket连接失败')
        // 打印失败的数据
        console.log(res)
      }
    },
    // 查询所有空间下配置的最小可预约时间
    async handleQueryShowDayMin(value) {
      try {
        const res = await queryShowDayMin(value)

        if (res === -1) {
          const newDate = dayjs(this.getNowFormatDate(this.maxConfigShowDayMin))
          const curY = newDate.year()
          const curM = Number(newDate.format('MM'))
          const curD = Number(newDate.format('DD'))
          this.configShowDayMin = new Date(curY, curM - 1, curD - 1)
        } else {
          const newDate = dayjs().add(res, 'day')
          const curY = newDate.year()
          const curM = Number(newDate.format('MM'))
          const curD = Number(newDate.format('DD'))

          this.configShowDayMin = new Date(curY, curM - 1, curD - 1)
        }

        this.getWeekdayTime(new Date())
      } catch (error) { }
    },
  },
  mounted() {
    this.scheduleNextCheck();
    this.user = JSON.parse(localStorage.getItem('user'))
    this.getAreaId(this.user.companyId)
    this.height = document.body.scrollHeight - 135
    // this.handleQueryShowDayMin({ companyId: this.user.companyId })

    // 查询工位预约列表
    this.connectWebSocket()

    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
  watch: {},
  beforeDestroy() {
    this.webSocket && this.webSocket.close()
    this.stopSchedule();
  },
}
</script>
<style lang="less" scoped>
// .content {
//   padding: 10px 6px 0;
//   margin-top: 10px;
// }
.stationListWrapper {
  padding-bottom: 30px;
  background-color: #ffffff;
}

.myStationGoBlock {
  display: flex;
  align-items: center;

  img {
    width: 16px;
    height: 16px;
  }
}

.myStationGo {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #1E2329;
  margin-right: 4px;
}

.selectionBar {
  height: 40px;
  background: #F2F2F6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  width: 100%;
  padding-top: 6px;
  padding-right: 12px;
  padding-left: 12px;

  >div {
    display: flex;
    // width: 50%;
    align-items: center;

    span {
      padding: 0px 4px;
    }
  }

  img {
    height: 16px;
  }

  .meetingArea {
    height: 40px;
    appearance: none;
    font-size: 14px;
    background: #ffffff;
  }
}

.selectionBar-area {
  justify-content: flex-start;
  padding-right: 12px;
  width: 180px;
  align-items: center;

  .area-font {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1E2329;
    margin-left: 4px;
    max-width: 140px;
    flex-wrap: nowrap;
  }

  .selectionBar-location {
    height: 24px;
    width: 24px;
  }

  .selectionBar-down {
    height: 20px;
    width: 20px;
  }
}

.selectionBar-downO {
  height: 20px;
  width: 20px;
  // margin-top: 5px;
}

.calendarWeed {
  display: flex;
  align-items: center;
  width: 100%;
  // height: 64px;
  background: #F2F2F6;
  padding-top: 12px;
  padding-bottom: 12px;

  .timeLine {
    display: flex;
    align-items: center;
    width: 89%;
    height: 64px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    -webkit-overflow-scrolling: touch;
    padding: 0 0 0 4px;
  }

  .dayBlock {
    display: flex;
    flex-flow: column;
    justify-content: space-around;
    align-items: center;
    height: 56px;
    // width: 48px;
    padding: 8px 0px;
    border-radius: 4px;
    margin-right: 3px;
    box-sizing: border-box;

    div {
      width: 44px;
      // height: 56px;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
    }

    .dayBlockweek {
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-size: 12px;
      color: #B7BDC6;
      line-height: 18px;
    }
  }

  .calendar {
    height: 64px;
    box-shadow: -15px -2px 5px -13px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      height: 24px;
      width: 24px;
    }

    .calendar-down {
      height: 8px;
      width: 8px;
    }
  }
}

.stationListWrapper-area {
  height: 50px;
  width: 100%;
  padding: 0 12px 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #EAECEF;
}

.selectionBar-areaO {
  display: flex;
  justify-content: flex-start;
  padding-right: 12px;
  width: 180px;
  align-items: center;

  .area-font {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #1E2329;
    margin-left: 4px;
  }

  .area-fontA {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #1E2329;
    max-width: 160px;
    flex-wrap: nowrap;
  }

  .selectionBar-location {
    height: 24px;
    width: 24px;
  }

  .selectionBar-down {
    height: 20px;
    width: 20px;
  }

  .selectionBar-downO {
    height: 20px;
    width: 20px;
    margin-top: 5px;
  }
}

.day-time {
  width: 148px;
  height: 32px;
  background: #F2F4F7;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #1E2329;
}

.day-timeLine {
  margin-left: 5px;
  margin-right: 5px;
}

.custom-time {
  width: 148px;
  height: 32px;
  padding: 0 6px 0 8px;
  box-sizing: border-box;
  background: #F2F4F7;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #1E2329;
}

.custom-timeLeft {
  display: flex;
  align-items: flex-end;
}

.custom-notime {
  width: 148px;
  height: 32px;
  padding: 0 6px 0 8px;
  box-sizing: border-box;
  background: #F2F4F7;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-family: PingFangSC, PingFang SC;
}

// /deep/.van-popup {
//   border-top-left-radius: 40px;
//   border-top-right-radius: 40px;
// }

.timeListTitle {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ebebeb;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.timeList {
  position: relative;
  height: 324px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 16px;
  overflow-y: auto;
  overflow-x: hidden;

  .timeListCard {
    height: 52px;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .timeListRange {
    display: block;
    border-bottom: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    height: 52px;
    width: 275px;
    line-height: 51px;

    .extra {
      padding-left: 24px;
    }
  }
}

.bookBox {
  height: 72px;
  background: #f7f7f7;
  padding: 6px 12px 0px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;

  .book-btn {
    height: 44px;
    background: #009bff;
  }
}

.appointmentStatusIconWrapper {
    display: flex;
    flex-direction: row;
    padding: 16px;
    margin-top: 80px;

    .typeStatusIcon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    .appointmentTypeStatusIcon {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .appointmentFlowStatusIcon {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #1e2329;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        margin-right: 8px;
      }
    }

    .appointmentStatusIcon {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #1e2329;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      margin-right: 20px;

      .iconItem {
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }
    }

    .appointmentTypeStatusIcon .appointmentStatusIcon:nth-last-child(1) {
      margin-right: 0;
    }
  }
</style>
